module.exports = __webpack_public_path__ + "static/media/team_6.f96e2778.png";